 import { Button } from "../../../components/ui/button";

 export const columns = [
        { key: "pharmacy_name", label: "Pharmacy Name" },
        { key: "owner_name", label: "Owner Name" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
        { key: "address", label: "Address" },
        {
            key: "status",
            label: "Status",
            render: (row) => (
                <span
                    className={`px-3 py-1 rounded-full text-xs font-semibold
        ${row.status === "active"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                >
                    {row.status === "active" ? "Active" : "Inactive"}
                </span>
            ),
        },

        {
            key: "edit",
            label: "Edit",
            render: () => (
                <Button
                 variant="admin.tracery">
                    Edit
                </Button>
            ),
        },
    ];

    export const data = [
        {
            pharmacy_name: "Dr. Amit Kumar",
            owner_name: "Rohit Sharma",
            email: "amit@hospital.com",
            phone: "9876543210",
            address: "Main Road, Patna",
            status: "active"
        }
    ];